/******************************************************
 *                  Timetables Ctrl
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("ExploitTimetablesCtrl", ["$scope", "ExploitTimetablesService", "toastr", "timetables", "$uibModal", "Utils",
		function ($scope, ExploitTimetablesService, toastr, timetables, $uibModal, Utils) {

		/******************************************************
             *                  SETUP
             ********************************************************/
		$scope.data = {
			timetables: timetables.data,
			isOpenedStartDate: false,
			isOpenedEndDate: false,
			hideExpiredTimetables: true,
			search: {}
		};


		// Date picker
		var DATE_PICKER_FORMAT = "dd/MM/yyyy",
			deleteModal;

		$scope.open = function ($event, isOpened) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.data[isOpened] = true;
		};

		$scope.format = DATE_PICKER_FORMAT;

		// Pagination
		$scope.data.timetables.currentPage = 1;

		angular.element("#advanced-dropdown-search").on("click", function (event) {
			event.stopPropagation();
		});


		/******************
             * SCOPE FUNCTIONS
             ******************/


		/**
             * Ouvrir la modal de suppression d'un calendrier.
             */
		$scope.openDeleteModal = function (timetable) {
			$scope.data.timetableToDelete = timetable;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope, "md");
		};


		/**
             * Supprimer un calendrier, notifications, et fermer la modale en cas de succès.
             * @param timetable le calendrier à supprimer
             */
		$scope.deleteTimetable = function (timetable) {
			ExploitTimetablesService.deleteTimetable(timetable)
				.then(() => {
					$scope.refreshTimetables();
					toastr.success("Le calendrier " + timetable.version + " a bien été supprimé.", "Calendrier supprimé");
					deleteModal.close();
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la suppression du calendrier. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};


		$scope.refreshTimetables = function () {
			return ExploitTimetablesService.refreshTimetables($scope);
		};

		$scope.getTimetableCardColor = ExploitTimetablesService.getTimetableCardColor;




	}]
	)
;
